/**
 * ZITELOU - 404 Page
 */

import React from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon } from '@heroicons/react/24/outline';
import { Button } from '../components/Common';

const NotFound = () => {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="text-center">
        <div className="flex justify-center mb-8">
          <img
            src="/logo-mark.svg"
            alt="Zitelou Logo"
            className="h-20 w-20"
          />
        </div>
        <h1 className="text-9xl font-bold text-primary">404</h1>
        <h2 className="text-3xl font-semibold text-gray-900 mt-4">
          Page non trouvée
        </h2>
        <p className="text-gray-600 mt-4 max-w-md mx-auto">
          Désolé, la page que vous recherchez n'existe pas ou a été déplacée.
        </p>
        <div className="mt-8">
          <Link to="/dashboard">
            <Button variant="primary" leftIcon={<HomeIcon className="w-5 h-5" />}>
              Retour au tableau de bord
            </Button>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
